import React from 'react'
import {Link as RouteLink} from 'react-router-dom'
import PropTypes from 'prop-types'
/**
 * A functional component that conditionally wraps its children with a RouteLink component.
 *
 * @param {Object} props - The properties object.
 * @param {string} props.link - The URL to which the RouteLink should navigate. If not provided, the children are returned as-is.
 * @param {React.ReactNode} props.children - The child elements to be wrapped by the RouteLink if a link is provided.
 *
 * @returns {React.ReactNode} - The children wrapped in a RouteLink if a link is provided, otherwise the children are returned directly.
 */
export const WrapperBdageLink = ({link, children}) => {
    return link ? <RouteLink to={link} style={{ textDecoration: 'none' }}>{children}</RouteLink> : children
}

WrapperBdageLink.propTypes = {
    link: PropTypes.string,
    children: PropTypes.node
}
